// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"6e5f9eec","143":"20f92554","219":"227a1658","324":"bfedf2d6","652":"8f1b71a9","704":"e03f2341","784":"2ba79e03","898":"860a3b58"}[chunkId] + ".chunk.js";
};